<template>
    <div id="mulpBetArea" class="fit v-scrollarea q-scrollarea" :class="getFormHeightClass()" style="width:221px !important;background-color: var(--qq--y0-bg-color12);">
        
    <!-- <div class="fit v-scrollarea q-scrollarea" style="width:221px !important" :style="{height: heightPX +'px !important'}"> -->
        <div class="q-scrollarea__container scroll relative-position fit hide-scrollbar" id="normalScroll">
            <div id="q-scroll-content" class="q-scrollarea__content absolute">
                <div id="normal-middle-content" class="middle-content" :style="midContent">
                    <div class="scroll-inner-wrap fit" id="midLeftBar">
                        <div class="menu-wrap" v-show="!oddSelected && selectedTab != 'betSlipTab'">
                            <div class="menu-item menu-top menu-roll menu-border" :class="{'active':open_RBMarket&&selectedMarket==market.inPlayMarket.key}" @click.prevent="openRBMarket(market.inPlayMarket.key, rbAllSport)">
                                <div class="inplay-icon"></div>
                                <div class="col">{{ langList.welcomeInPlay }}</div>
                                <span class="bet-count">{{ allLive(market.inPlayMarket.key) }}</span>
                            </div>
                            <div class="menu-item menu-top menu-roll menu-border" 
                            :class="{'active':selectedMarket==market.hotSportMarket.key}" 
                            v-if="hotSport != 0"
                            @click.prevent="changeMarket(market.hotSportMarket.key, rbAllSport)">
                                <div class="hotSport-icon"></div>
                                <div class="col">{{ langList.hotSport }}</div>
                                <!-- <span class="bet-count">{{ allLive(market.hotSportMarket.key) }}</span> -->
                            </div>
                            <div class="c-menu-sports menu-border">                                    
                                <div data-v-20a71bf8="" class="relative-position">
                                    <div data-v-20a71bf8="" class="menu-item menu-top menu-item-title disable-hover">{{ langList.sportMenu }}</div>
                                    <div data-v-20a71bf8="" class="menu-item menu-tab disable-hover double">
                                        <div data-v-20a71bf8="" class="item yb-flex-center " :class= " selectedMarket==market.tdyMarket.key || selectedMarket==market.inPlayMarket.key ? 'active' : '' "  @click.prevent="changeMarket(market.tdyMarket.key)">{{ langList.GAME_BANNER['GAME_BANNER.TODAY'] }}</div>
                                        <div data-v-20a71bf8="" class="item yb-flex-center " :class= " selectedMarket==market.earlyMarket.key ? 'active' : '' " @click.prevent="changeMarket(market.earlyMarket.key)">
                                            <span class="ellipsis" style="width: 85px; text-align: center;">{{ langList.GAME_BANNER['GAME_BANNER.EARLY'] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <sportCategory></sportCategory>
                            </div>
                            <!-- <div class="menu-item menu-top menu-virtual menu-border" >
                                <span data-v-0d68232c="" class="q-icon icon c-icon sport-img img36" style="width: 18px; height: 18px; background-position: 0px -943.5px;"></span>
                                <div class="menu-name col">{{ langList.sports_info_lang['SPORT_INFORMATION.OUTRIGHT'] }}</div>
                                <div class="col-right"><span class="match-count yb-family-odds">2</span></div>
                            </div> -->
                        </div>


                        <!-- bet form -->
                        <bettingForm v-if="openBetForm && miniNormal!='1'"></bettingForm>
                        <betSlipForm v-if="selectedBetTab"></betSlipForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import EventBus from '../../../events/event-bus'
import allBetMixin from '@/vue/mixins/allBet'
import sportMatchCount from '@/vue/mixins/sportMatchCount'
import sportCategory from './sportCategory'
import bettingForm from './bettingForm'
import betSlipForm from './betSlipForm'

import {
    mapGetters
} from 'vuex'

export default {
    mixins: [ allBetMixin, sportMatchCount ],
    components: {
        sportCategory,
        bettingForm,
        betSlipForm,
    },
    computed: {
        ...mapGetters([
            'account',
            'market',
            'selectedMarket',
            'selectedBettype',
            'selectedSport',
            'sportList',
            'hot_sportList',
            'langList',
            'oddSelected',
            'allSportCount',
            'open_RBMarket',
            'betForm',
            'openBetForm',
            'frameWidthHeight',
            'miniNormal',
            'selectedTab',
            'selectedBetTab',
        ]),
        midContent: function(){
            var a = (!this.$store.getters.oddSelected && !this.$store.getters.openBetForm) ? '81' : '115' 
            var b = this.tvIconFlag ? 40 : 0
            var c = this.showGameBanner? 83 : 0; // left side banner height
            if(this.tvIconFlag && !this.$store.getters.oddSelected && !this.$store.getters.openBetForm){
                a = parseInt(a)+b+c
            }
            if(this.$store.getters.selectedBetTab && !this.$store.getters.openBetForm && !this.$store.getters.showbetformMenu){
                a = 120+c // 120 = username tab height + return tab height + mybet tab height
            }else if(this.betForm.length > 0 && this.$store.getters.showbetformMenu){
                a = this.$store.getters.openBetForm ? 120 : 120+b+c
            }
            return 'padding-top: '+a+'px; padding-bottom: 0px;'
        },
        heightPX: function () {
            return this.$store.getters.frameWidthHeight.height.currentHeight-100
        },
        selectedTab: function () {
            return this.$store.getters.selectedTab
        },
    },
    watch: {
      betForm: {
        handler(val, oldVal) {
            if(this.betForm.length > 0){
                this.showBetForm = true;
            }
        }
      },
    },
    props :{
        isMini: Boolean,
    },
    data() {
        return{
            showBetForm: false,
            rbAllSport: {
            "sprtId": "G98",
            },
            // lang: window.lang,
            sport_profile: window.def_sport_profile,
            hotSport: window.hotSport,
            showGameBanner: false,
            tvIconFlag: window.tvIconFlag? true:false,
        }
    },
    methods: {
        getFormHeightClass(){
            var bet = this.$store.getters.betting
            var isMulp = this.$store.getters.selectedBettype
            if(this.isUsingPhone() === 1 && this.$store.getters.openBetForm && isMulp.betTypId!='5' && (!bet.success && !bet.pending && !bet.reject && !bet.betcombosuccess)){
                return 'betForm-scrollArea-phone'
            } else if ( this.$store.getters.openBetForm && isMulp.betTypId!='5' && (!bet.success && !bet.pending && !bet.reject && !bet.betcombosuccess)){
                return 'betForm-scrollArea'
            } else if(!this.$store.getters.openBetForm) {
                return 'sportMenu-scrollArea'
            } else if(this.isUsingPhone() === 1 && this.$store.getters.openBetForm && (bet.success||bet.pending||bet.reject||bet.betcombosuccess)) {
                return 'betSlip-scrollArea-phone'
            } else if(this.$store.getters.openBetForm && (bet.success||bet.pending||bet.reject||bet.betcombosuccess)) {
                return 'betSlip-scrollArea'
            } else if(this.isUsingPhone() === 1 && isMulp.betTypId=='5'){
                return 'mulpbetForm-scrollArea-phone'
            } else if(isMulp.betTypId=='5'){
                return 'mulpbetForm-scrollArea'
            }
        },
        changeMarket(market, stpid) {
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit("LIVE_SCHECULE", false);
            EventBus.$emit('viewAccountSetting', false)
            if(window._gameBanner && this.$store.getters.isGameBannerSelected){
                this.$store.commit("GAMEBANNER_SELECTED", true);
            } else {
                this.$store.commit("GAMEBANNER_SELECTED", false);
            }
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('OPEN_RBMARKET', false)
            this.$store.commit('EVENTLIST', [])
            this.$store.commit('FAVOURITEEVENTCOUNT', 0)
            switch(market){
                case this.$store.getters.market.inPlayMarket.key:
                    this.$store.commit('SPORTFORECAST_LIST', null) 
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.inPlayMarket.key)
                    this.resetSportBettype()
                    EventBus.$emit('refreshOdd', true );
                    EventBus.$emit('marketChange', this.$store.getters.market.inPlayMarket.key );
                    this.$store.commit('HOT_SCHEDULE', false)
                    this.$store.commit('SPECIAL_EVENT', false)
                break;
                case this.$store.getters.market.tdyMarket.key:
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key)
                    var spt = this.$store.getters.specialEvent? this.$store.getters.specialEventList['sprtId']:this.$store.getters.sportList[0]
                    this.$store.commit('SELECTED_SPORT', spt)
                    EventBus.$emit('refreshOdd', true );
                    if(this.$store.getters.specialEvent) {
                        EventBus.$emit('getSpecialEvent');
                    } else {
                        this.resetSportBettype()
                        EventBus.$emit('marketChange', this.$store.getters.market.tdyMarket.key );
                    }
                    this.$store.commit('HOT_SCHEDULE', false)
                break;
                case this.$store.getters.market.earlyMarket.key:
                    this.$store.commit('SORTEDRBEVENTLIST', [])
                    this.$store.commit('RBEVENTLIST', [])
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.earlyMarket.key)
                    this.$store.dispatch('getEarlyEventCountByDate');
                    var spt = this.$store.getters.specialEvent? 'SP':this.$store.getters.sportList[0]
                    this.$store.commit('SELECTED_SPORT', spt)
                    EventBus.$emit('refreshOdd', true );
                    if(this.$store.getters.specialEvent) {
                        EventBus.$emit('getSpecialEvent');
                    } else {
                        this.resetSportBettype()
                        EventBus.$emit('marketChange', this.$store.getters.market.earlyMarket.key );
                    }
                    this.$store.commit('HOT_SCHEDULE', false)
                break;
                case this.$store.getters.market.hotSportMarket.key:
                    if(this.$store.getters.selectedMarket != this.$store.getters.market.hotSportMarket.key) this.$store.commit('PREV_MARKET', this.$store.getters.selectedMarket)
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.hotSportMarket.key)
                    // this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[0])
                    this.$store.commit('SELECTED_BETTYPE',  this.$store.getters.bettypeList[0])
                    this.$store.commit('SELECTED_SPORT', this.rbAllSport)
                    EventBus.$emit('inplaySportChange', this.rbAllSport );
                    EventBus.$emit('refreshOdd', true );
                    EventBus.$emit('marketChange', this.$store.getters.market.hotSportMarket.key );
                    this.$store.commit('HOT_SCHEDULE', true)
                    this.$store.commit("GAMEBANNER_SELECTED", false);
                    this.$store.commit('SIMPLE_SPORT', null)
                    this.$store.commit('SPECIAL_EVENT', false)
                break;
            default:
                return false;
            }
            this.$store.dispatch('getSportEventList', {
                token: token.arr_2
            })
            if(window._gameBanner){
                this.$store.dispatch("getSportEventList", {
                    market: "1,2,3",
                    isGameBanner: true,
                    callback: (res => {
                    }).bind(this)
                })
            }
        },
        allLive(market) {
            var allLiveSport = this.allSportCount['live']
            var count = []
            $.each(allLiveSport, function(sport, bettype){
               if(sport.charAt(0)=='N'){
                $.each(bettype, function(key, val){
                    if(key == 'RAH'){
                        count.push(val)
                    }
                })
               }
            })

            return _.sum(count)
        },
        openRBMarket(market, sport) {
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit('HOT_SCHEDULE', false);
            this.$store.commit('SPECIAL_EVENT', false);
            // this.$store.commit('SIMPLE_SPORT', null)
            EventBus.$emit('viewAccountSetting', false)
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('SORTEDRBEVENTLIST', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('MERGE_LEAGUELIST', null)
            this.$store.commit('FAVOURITERBEVENTCOUNT', 0)
            
            this.$store.commit('SPORTFORECAST_LIST', null)  
            this.$store.commit('OPEN_RBMARKET', true)
            this.$store.commit('SELECTED_MARKET', market)
            EventBus.$emit('inplaySportChange', sport );
            this.$store.commit('SELECTED_BETTYPE',  this.$store.getters.bettypeList[0])
            this.$store.commit('SELECTED_SPORT', sport)
            this.$store.commit("LIVE_SCHECULE", false)

            // this.resetSportBettype()
            EventBus.$emit('refreshOdd', true );
            EventBus.$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
            
            this.$store.dispatch('getSportEventList', {
                token: token.arr_2
            })
        },
        title_display(selectedMarket){
            if(selectedMarket==1){
                return this.langList.welcomeTdyMarket;
            }else if(selectedMarket==3){
                return this.langList.welcomeInPlay;
            }else{
                return this.langList.welcomeEarlyMarket;
            }
        },
        getAllSportCount(comid){
            // 60 sec to get once
            var Vue = this

            Vue.$store.dispatch('getSportCount');

            setInterval(function(){
                Vue.$store.dispatch('getSportCount');
            }, 60000)
        },
        hideContent() {
            var showNav = $('.nav-widgetPanel').hasClass('showNav')
            if(showNav){
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.expendScore').css('width', '');
            }
            // $('.widgetPanel.sportsMenu.special').find('.threeColum').removeClass('showNav')
            $('.nav-widgetPanel').removeClass('showNav')
            $('.sportsMenu').removeClass('active')
        },
        showNav() {
            var mini = $('.sidebar-first').hasClass('mini')
            if(mini){
                var showNav = $('.nav-widgetPanel').hasClass('showNav')
                if(showNav){
                    $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                    $('.widgetArea').find('.expendScore').css('width', '');
                    
                    $('.nav-widgetPanel').removeClass('showNav')
                    $('.sportsMenu').removeClass('active')
                }else{
                    $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
                    $('.widgetArea').find('.expendScore').css('width', '40em');

                    $('.nav-widgetPanel').addClass('showNav')
                    $('.sportsMenu').addClass('active')
                } 
            }
        },
        showSport() {
            $('.sportsMenu').removeClass('collapsed')
            
            var isBetSlip = $('.widgetPanel.group').hasClass('betSlip')
            
            if(isBetSlip){
                $('.betSlip').removeClass('active')
                $('.betSlip').addClass('collapsed')
            }else{
                $('.betList').removeClass('active')
                $('.betList').addClass('collapsed')
            }
        }
    },
    mounted () {
        this.getAllSportCount(this.account.comId)
    }, 
    beforeMount() {
        this.$store.dispatch('getSportCCL', {
            token: token.arr_7,
        })
        if(!_.isUndefined(this.sportBettypeList)){
            this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList,'sprtId'))
        }
        if(hotSport){
            if(this.sport_profile && !_.isUndefined(this.sport_profile['hot_sportList'])){
                this.$store.commit('HOT_SPORTLIST', _.uniqBy(this.sport_profile['hot_sportList'],'sprtId'))
            }
        }


        if(window._gameBanner) {
            this.showGameBanner = true
        } else if(window._imageBanner && window._gameBannerImage && window._gameBannerImage.position && window._gameBannerImage.position.includes('l')) {
            this.showGameBanner = true
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/allSport.vue